function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.97659 9.50326H10.5033L13.8299 12.8366L12.8366 13.8299L9.50326 10.5033V9.97659L9.32326 9.78992C8.56326 10.4433 7.57659 10.8366 6.50326 10.8366C4.10992 10.8366 2.16992 8.89659 2.16992 6.50326C2.16992 4.10992 4.10992 2.16992 6.50326 2.16992C8.89659 2.16992 10.8366 4.10992 10.8366 6.50326C10.8366 7.57659 10.4433 8.56326 9.78992 9.32326L9.97659 9.50326ZM3.50371 6.50337C3.50371 8.16337 4.84371 9.50337 6.50371 9.50337C8.16371 9.50337 9.50371 8.16337 9.50371 6.50337C9.50371 4.84337 8.16371 3.50337 6.50371 3.50337C4.84371 3.50337 3.50371 4.84337 3.50371 6.50337Z"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.d9672ed6.svg";
export { ForwardRef as ReactComponent };